import React, { useEffect, useRef, useState } from 'react';
import styles from './locateServices.module.scss';
import {
  Medium14,
  PrimaryButton,
  SemiBold14,
  SemiBold20,
} from '@/components/design-system';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import { classNames } from '@/core/utils/class.utils';
import { openUrlInNewTab } from '@/core/utils/general.utils';
import { useDashboard } from '@/contexts/dashboard/dashboard.context';
import { renderCards } from '../../helper';

const LocateServices = () => {
  const { dashboardLabels } = useDashboard();
  const data = renderCards(dashboardLabels.locateServices.cards);
  const divRefs = useRef<Map<string, HTMLDivElement>>(new Map());
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  useEffect(() => {
    const currElement = divRefs.current.get(selectedIndex.toString());
    if (currElement && scrollRef.current) {
      scrollRef.current.scrollTo({
        behavior: 'smooth',
        left: currElement.offsetLeft - scrollRef.current.offsetLeft,
      });
    }
  }, [selectedIndex]);

  if (data.length === 0) return <></>;

  const scrollToPrevious = () => {
    if (selectedIndex > 0) {
      setSelectedIndex(selectedIndex - 1);
    }
  };

  const scrollToNext = () => {
    if (selectedIndex < data.length - 1) {
      setSelectedIndex(selectedIndex + 1);
    }
  };

  return (
    <div className={styles['locate-hsp-con']}>
      <div className={styles['section-con']}>
        <IconChevronLeft
          size={18}
          onClick={scrollToPrevious}
          className={classNames(styles['arrow'], {
            [styles['disabled']]: selectedIndex === 0,
          })}
        />
        <div className={styles['sections']} ref={scrollRef}>
          {data.map((section, index) => {
            return (
              <div
                ref={(el) => {
                  if (el) {
                    divRefs.current.set(index.toString(), el);
                  }
                }}
                onClick={() => {
                  setSelectedIndex(index);
                }}
                className={classNames(styles['section-title'], {
                  [styles['selected']]: selectedIndex === index,
                })}
                key={index}
              >
                {section.sectionName}
              </div>
            );
          })}
        </div>
        <IconChevronRight
          size={18}
          onClick={scrollToNext}
          className={classNames(styles['arrow'], {
            [styles['disabled']]: selectedIndex === data.length - 1,
          })}
        />
      </div>
      <div className={styles['title-desc-con']}>
        <SemiBold20 color="secondary">{data[selectedIndex].title}</SemiBold20>
        <Medium14 color="body">{data[selectedIndex].description}</Medium14>
      </div>
      <div className={styles['btn-con']}>
        <PrimaryButton
          parentWidth
          onClick={() => openUrlInNewTab(data[selectedIndex].redirectionLink)}
          clevertapEventPayload={
            dashboardLabels.locateServices.buttonTextClevertapEvent?.payload
          }
          clevertapEventName={
            dashboardLabels.locateServices.buttonTextClevertapEvent?.name
          }
        >
          <SemiBold14 color="var(--white)">
            {data[selectedIndex].btnText}
          </SemiBold14>
        </PrimaryButton>
      </div>
    </div>
  );
};

export default LocateServices;
